import React from 'react'
import BurgerMenuTitle from '../../Component/BurgerMenuTitle/BurgerMenuTitle'
import Style from './ComingSoon.module.css'

const ComingSoon = () => {
  return (
    <div className={Style.pageHolder}>
        <BurgerMenuTitle title=""/>
        <h2 className={Style.english}>Coming soon ...</h2>
        <h2 className={Style.persian}>...به زودی</h2>
    </div>
  )
}

export default ComingSoon